import React,{ useState } from 'react';
import styled from 'styled-components';
import {NavLink} from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { useForm } from 'react-hook-form';

// Components
import StyledPage from '../components/StyledPage';

import AuthLayoutWrapper from '../components/AuthLayoutWrapper';
import FormErrors, { trowError } from '../components/FormErrors';
import Button from '../components/Button';

import ReCAPTCHA from 'react-google-recaptcha';

import { CREATE_ACREDITACION } from '../models/AcreditacionProfile';


export default() => {
    const [ LoginInForm, { loading }] = useMutation(CREATE_ACREDITACION);

    const { register, handleSubmit, watch, errors:errors_fomr } = useForm({
        defaultValues:(process.env.NODE_ENV==='development')?{
            email:'datarandomtestinfo@mailinator.com'
        }:{}
    });
    const [submitError,setSubmitError] = useState<null|string>(null);
    const [submitConfirm,setSubmitConfirm] = useState<null|string>(null);

    const recaptchaRef = React.useRef<any>();
    
    const onSubmit = async (data:any) => {
        setSubmitConfirm(null);
        setSubmitError(null);  

        console.log('on Send data:',data);
        try{
            let tokenCaptcha=null;
            if(process.env.REACT_APP_RECAPTCHA_ENABLED==='true'){
                tokenCaptcha = await recaptchaRef.current.executeAsync();
                recaptchaRef.current.reset(); 
            }
            
            let response=await LoginInForm({ 
                variables:{
                    input:{
                        ...data
                    }
                },
                context:{
                    clientName: 'LOGIN',
                    headers:{
                        'x-recapchatoken':tokenCaptcha
                    }
                }                
            });

            if(response.errors)
                throw new trowError(response.errors);

            /// setSubmitConfirm('Se ha enviado el correo de confirmación');
            setSubmitError(null);

            location.href=`/registro-atleti-id/uuid/${response.data.createProfile.uuid}`;
        }catch(e){
            console.error(e);
            setSubmitError(e);
        }
    }
  
    return (
        <StyledPage>
            <AuthLayoutWrapper>
                <p>Para iniciar la activación de tu cuenta, introduce a continuación la cuenta de correo electrónico que proporcionaste cuando adquiriste tu Abono ADSL.</p>
                <br/>
                <br/>
                <p>Te enviaremos automáticamente un correo electrónico con un link. Da click en él y completa el proceso de activación de tu cuenta. </p>
                <br/>
                <br/>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <ReCAPTCHA sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY || ''} size="invisible" ref={recaptchaRef} />

                    {submitError?<div className="error-message"><FormErrors errors={submitError} /></div>:null}
                    {submitConfirm?<div className="successful-message">{submitConfirm}</div>:null}
                    <input type='email' name="email" placeholder='Correo electrónico' ref={register} required/>
                    <Button type='submit' disabled={loading} className="important">Validar correo electrónico</Button>
                </form>
                <br/>
                <br/>
                <p>* Si eres abonado y tienes algún problema para lograr tu acceso , contáctanos vía email a abonados@atleticodesanluis.mx o vía Whatsapp, al <a href="https://api.whatsapp.com/send?phone=524441118872" target="_blank">444-111-8872</a></p>
                <p><NavLink to='/login'>Volver</NavLink></p>
            </AuthLayoutWrapper>
        </StyledPage>
    )
};